import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router'
import { userActions } from '../../actions/user.actions';
import "./styles.css";
import { userConstants } from '../../constants/user.constants';

export default class HomeScreen extends Component {
  state = {activeItem: ''}

  constructor(props) {
    super(props)
  }

  render() {
    const { me, dispatch } = this.props;
    
    dispatch(userActions.me());

    if (me?.Role === userConstants.ROLE_USER_MANAGER) {
      return (
        <Redirect to="/users" />
      )
    }

    return (
      <Redirect to="/requests" />
    )
  }
}

function mapStateToProps(state) {
    const { users, authentication } = state;
    const { user } = authentication;
    return {
        user,
        users,
        me: users.me || null
    };
}

const connectedHomeScreen = connect(mapStateToProps)(HomeScreen);
export { connectedHomeScreen as HomeScreen };
